import { makeStyles, createStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';
import * as spacing from 'styles/spacing';

const useStyles = makeStyles(theme =>
  createStyles({
    statusChart: {
      display: 'flex',
      justifyContent: 'center',
      boxShadow: 'none',
      width: '100%',
      '& > div': {
        paddingTop: '0px',
        width: '95%',
        '& #center-container > div > div > div > svg > g > text': {
          fontSize: `${spacing.default.xxsmall}`,
          color: colors.chartLegend,
          fontWeight: fonts.weights.normal,
          letterSpacing: '0.4px',
          lineHeight: '16px',
          marginLeft: '8px',
        },
      },
    },
    labelItem: {
      color: colors.black,
      fontWeight: fonts.weights.normal,
      fontSize: fonts.sizes.xxsmall,
    },
    labelContainer: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr ',
      [theme.breakpoints.down('lg')]: {
        gridTemplateColumns: '1fr 1fr 1fr ',
      },
      maxWidth: '100%',
      paddingBottom: '0',
      '& > li': {
        padding: '4px 6px',
      },
    },
    labelText: {
      '& > span': {
        whiteSpace: 'nowrap',
        color: colors.chartLegend,
        fontWeight: fonts.weights.normal,
        fontSize: fonts.sizes.small,
        letterSpacing: '0.25px',
        lineHeight: '20px',
      },
    },
    labelMarker: {
      display: 'none',
    },
    barLabel: {
      color: colors.chartLegend,
      fontWeight: fonts.weights.medium,
      fontSize: fonts.sizes.xxsmall,
      letterSpacing: '1.5px',
      lineHeight: '16px',
      marginLeft: '8px',
    },
    noData: {
      display: 'grid',
      height: '100px',
      color: colors.gray,
      alignContent: 'center',
      justifyContent: 'center',
      justifyItems: 'center',
      margin: '10% 50%',

      '& p': {
        width: '300px',
        display: 'flex',
        justifyContent: 'center',
      },
    },
  }),
);

export default useStyles;
